<template lang="pug">
FetchErrorTransition(:isFetching="isFetching" :error="error")
  .visitor-segments-overview.p-L
    .top-line
      h1.h1 Visitor Classifications
    SegmentsTable(v-if="classification" :classification="classification" :canCreateSegments="canCreateSegments" :canEditSegments="canEditSegments")
    p(v-else) There are currently no classifications
</template>

<script>
import SegmentsTable from '@/vue/settings/application/visitorclassifications/SegmentsTable.vue'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'VisitorClassificationsOverview',
  components: { SegmentsTable },
  props: { canCreateSegments: Boolean, canEditSegments: Boolean },
  data() {
    return {
      isFetching: true,
      error: null,
    }
  },
  computed: mapState('visitorClassifications', ['classification']),
  methods: mapActions('visitorClassifications', ['maybeFetchFirstClassification']),
  async mounted() {
    this.isFetching = true
    try {
      await this.maybeFetchFirstClassification()
      this.isFetching = false
    } catch (e) {
      this.$store.dispatch('notification/add', {
        type: 'error',
        message: 'Unable to fetch classification',
      })
      this.error = e
      this.isFetching = false
    }
  },
}
</script>
